import React from 'react';
import "./App.css";
import ntt_logo from './nttlogo.png'
import banner from "./Form Banner.png"


const Header = () => {
  return (
    <div >
      <img
        src={banner}
        alt="Form Banner"
        className="banner-image"
      />
    </div>
  );
};

export default Header;

